// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"617bb1d9","732":"ba95c908","977":"5098dc4f"}[chunkId] + ".chunk.js";
};